// extracted by mini-css-extract-plugin
module.exports = {"searchSourcesRoot":"PyHgVbEM","title":"HbcQZwcq","logotypes":"mm8JTt0Z","img":"aVaqb4fn"};